import clsx from "clsx";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import './styles.scss';

export default function MapControls({
    className,
    onZoomIn = () => {},
    onZoomOut = () => {},
    onLocate = () => {}
}) {
    const isTablet = useMediaQuery('(max-width: 992px)');

    return <div className={clsx('map-controls', className)}>
        {!isTablet && <div className="map-controls__group">
            <button className="map-controls__button" type="button" onClick={onZoomOut}>
                <img src="/files/images/icons/minus.svg" alt="" />
            </button>
            <button className="map-controls__button" type="button" onClick={onZoomIn}>
                <img src="/files/images/icons/plus.svg" alt="" />
            </button>
        </div>}
        <button className="map-controls__button" type="button" onClick={onLocate}>
            <img src="/files/images/icons/location.svg" alt="" />
        </button>
    </div>
}